import React from "react";
import "./refrigerated-truck.css";
import RefrigeratedPlanCard from "../global/RefrigeratedPlanCard";

const RefrigeratedTruckSuccess = () => {
  return (
    <section className="refrigerated-plans-section py-5 texture-background">
      <div className="container-fluid container-lg">
        <div className="refrigerated-plans-content mx-auto text-center">

          {/* Heading */}
          <h2
            data-aos="fade-up"
            className="refrigerated-plans-title"
          >
            Success Stories of Our Refrigerated Truck Rentals in Dubai & Abu Dhabi
          </h2>

          {/* Intro */}
          <p
            data-aos="fade-up"
            data-aos-delay="150"
            className="refrigerated-plans-desc work-desc mx-auto"
          >
            Delivering reliability when timing and temperature matter most. 
            Here are real examples of how our <strong>refrigerated truck rental services</strong> 
            helped businesses maintain cold chain logistics across the UAE.
          </p>

          {/* Stories */}
          <div className="row mt-4">

            {/* Story 1 */}
            <div className="col-12 col-sm-6 mb-4">
              <RefrigeratedPlanCard
                title="Palm Jumeirah Event Rescue"
                description={
                  <>
                    During a peak summer event in Palm Jumeirah with over 2,000 guests,
                    food supplies were at risk due to extreme heat exceeding 43°C. Our
                    team quickly deployed{" "}
                    <strong>5-ton and 3-ton refrigerated trucks</strong> to stabilize
                    temperature-sensitive items. The food was preserved safely and
                    delivered on time, preventing major losses and ensuring event success.
                  </>
                }
                titleClassName="refrigerated-plan-title text-center"
                descriptionClassName="refrigerated-plan-desc text-center"
                cardAosProps={{ "data-aos": "zoom-in" }}
              />
            </div>

            {/* Story 2 */}
            <div className="col-12 col-sm-6 mb-4">
              <RefrigeratedPlanCard
                title="Bakery Supply Chain Reliability"
                description={
                  <>
                    A bakery supplying multiple cafés and supermarkets struggled with
                    product freshness during UAE summers. Using our{" "}
                    <strong>3-ton refrigerated truck</strong>, we maintained consistent
                    temperature control for daily deliveries. This ensured fresh baked
                    goods, reduced spoilage, and improved operational efficiency across
                    Dubai and Abu Dhabi.
                  </>
                }
                titleClassName="refrigerated-plan-title text-center"
                descriptionClassName="refrigerated-plan-desc text-center"
                cardAosProps={{ "data-aos": "zoom-in", "data-aos-delay": "150" }}
              />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default RefrigeratedTruckSuccess;